const buttonClasses = 'border-2 border-white text-white';

const buttonHoverClasses = 'hover:bg-white hover:text-primary-600 [&:hover_svg]:fill-primary-600';

const buttonIconClasses = 'fill-white';

const buttonWhiteOutlinedClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonWhiteOutlinedClasses;
